import { defineComponent, h } from 'vue';
import BaseComponent from './baseFormMixin.jsx';
import utils from '../../../Shared/utils.jsx';
import { QRadio, QField, QIcon } from 'quasar';

import TranslationContainer from '../TranslationContainer.jsx';

export default defineComponent({
    name: 'sform-radios',
    mixins: [BaseComponent],
    components: {
        TranslationContainer,
        QRadio,
        QField,
        QIcon,
    },
    data: () => ({
    }),
    props: {
    },
    created() {
    },
    mounted() {
        this.loadComplete();
    },
    computed: {
        translatedHintText: function () {
            return this.inputHint;
        },
    },
    methods: {
    },
        render() {
            const locked = !!this.appearance?.readonly;
            let items;
            if (this.element.enum) {
                items = this.element.enum.map((e) => (
                    <QRadio
                        key={e}
                        val={e}
                        disable={locked}
                        modelValue={this.itemvalue}
                    onUpdate:modelValue={(value) => this.sync(value)}
                    onBlur={this.onBlur}
                    onFocus={this.onFocus}
                >
                    <TranslationContainer context={this} value={e}></TranslationContainer>
                </QRadio>
            ));
        } else if (this.element.titleMap) {
            items = this.element.titleMap.map((e) => (
                <QRadio
                    key={e.value}
                    val={e.value}
                    disable={locked}
                    modelValue={this.itemvalue}
                    onUpdate:modelValue={(value) => this.sync(value)}
                    onBlur={this.onBlur}
                    onFocus={this.onFocus}
                >
                    <TranslationContainer context={this} value={e.name}></TranslationContainer>
                </QRadio>
            ));
        }

        let title = <TranslationContainer context={this} value={this.labelText}></TranslationContainer>;
        if (this.hintText) {
            const hintIcon = utils.generateTooltip(h, <QIcon size="sm" class="form-hint-icon" name="mdi-information"></QIcon>, this.translatedHintText, 'right');
            title = (
                <span>
                    {title}
                    {' '}
                    {hintIcon}
                </span>
            );
        }

        const input = (
            <div
                style="border-width: 1px; border-color: gray; border-style: solid; border-radius: 8px; padding: 5px 0 0 10px;"
                class="q-mb-sm"
            >
                {title}
                <QField
                    ref="form"
                    modelValue={this.itemvalue}
                    rules={this.rules} {...this.compilerErrorFieldProps}
                    borderless
                    hide-bottom-space
                    dense
                    
                >
                    <div class="column">
                        {items}
                    </div>
                </QField>
            </div>
        );

        return input;
    },
});
